import { atom } from "jotai";

export const SaveSearch = atom<string[] | null>(null);
